import { useQuery } from '@apollo/client';
import React from 'react';
import { FetchAuditTrailListQuery } from '@css-xp/apd-common';
import { ErrorComponents } from '@css-xp/base';
import { useApplicationContext } from '@css-xp/base/common-context';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { fetchAuditTrailList } from '../queries/tasks';
import AuditTrailHeader from './audit-trail-header/audit-trail-header';
import AuditTrailPanel from './audit-trail-panel/audit-trail-panel';
import AuditTrailTable from './audit-trail-table/audit-trail-table';

function AuditTrail({ businessKey }: { businessKey: string }) {
  const user = useApplicationContext();
  const { data, loading, error } = useQuery<FetchAuditTrailListQuery>(fetchAuditTrailList, {
    skip: !user?.userId || !businessKey,
    variables: {
      id: user?.userId?.split('@')[0],
      businessKey: businessKey,
    },
  });
  if (loading) {
    return (
      <>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="25%" height="40px" />
        </SkeletonLoaderWrapper>
        <SkeletonLoaderWrapper>
          <SkeletonLoader height="200px" />
        </SkeletonLoaderWrapper>
      </>
    );
  }

  if (error) return <ErrorComponents.GenericErrorPage error={error} />;

  const taskList = data?.auditTrailTaskList?.tasks ?? [];

  return (
    <>
      <AuditTrailHeader title="Audit Trail" />
      {taskList.map((item: any, index: number) => (
        <AuditTrailPanel key={index} header={item?.taskName}>
          <AuditTrailTable data={item?.taskAuditTrail} />
        </AuditTrailPanel>
      ))}
    </>
  );
}

export default AuditTrail;
